import { render, staticRenderFns } from "./DashboardIcon.vue?vue&type=template&id=57eb5d86&scoped=true&"
import script from "./DashboardIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DashboardIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57eb5d86",
  null
  
)

export default component.exports